/** Lightweight regex-based redaction of common opsec leaks in markdown text.
 *  Returns the redacted string + a count of how many tokens were redacted.
 *  PATTERNS:
 *    - IPv4 (optionally with /CIDR)
 *    - IPv6 (loose)
 *    - email addresses
 *    - private/internal hostnames (foo.local, *.internal, *.lan)
 *    - long hex / base64 tokens >= 32 chars (likely API keys)
 *    - JWT (header.payload.sig)
 *
 *  Does NOT touch:
 *    - public CVE ids (CVE-YYYY-NNNN — keep these visible)
 *    - example domains (example.com / example.org)
 *    - markdown code-block fences
 */

const PATTERNS = [
    // JWT (3 base64 sections joined by dots)
    { rx: /\beyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\b/g, label: "JWT" },
    // Long hex / base64 tokens (API keys)
    { rx: /\b(?:[A-Fa-f0-9]{32,}|[A-Za-z0-9+/]{40,}={0,2})\b/g, label: "TOKEN" },
    // IPv4 with optional CIDR
    { rx: /\b(?<![A-Za-z])(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}(?:\/\d{1,2})?\b/g, label: "IP" },
    // IPv6 (loose — at least 2 groups separated by ::)
    { rx: /\b(?:[0-9a-fA-F]{1,4}:){2,7}[0-9a-fA-F]{1,4}\b/g, label: "IPv6" },
    // Emails
    { rx: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g, label: "EMAIL" },
    // Private/internal hostnames
    { rx: /\b[a-zA-Z0-9-]+\.(?:local|internal|lan|intranet|corp)\b/g, label: "HOST" },
];

export function redact(text) {
    let s = text || "";
    let count = 0;
    for (const { rx, label } of PATTERNS) {
        s = s.replace(rx, (match) => {
            // Preserve CVE ids and example domains
            if (/^CVE-\d{4}-\d{4,7}$/i.test(match)) return match;
            if (/example\.(com|org|net|test)/i.test(match)) return match;
            count++;
            return `<redacted:${label}>`;
        });
    }
    return { text: s, count };
}
